export default function Spinner({ text = "Loading..." }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <div
        className="spinner-border text-primary"
        role="status"
        aria-label="loading"
      />
      <span className="mt-2 text-muted">{text}</span>
    </div>
  );
}
